import { ChangeDetectionStrategy, Component } from '@angular/core';

import { FormManagerService } from '@sim/form';
import { BaseFiltersComponent, FilterFieldsOptions } from '@ui/ui.module';

import { CardMI, CardMIFilter, CardMIFiltersMeta } from '@atmi/core/models';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-card-mi-filters',
  styleUrls: ['./card-mi-filters.component.scss'],
  templateUrl: './card-mi-filters.component.html',
})
export class CardMiFiltersComponent extends BaseFiltersComponent<CardMI, FilterFieldsOptions<CardMIFilter>> {
  constructor(
    protected readonly formManager: FormManagerService,
  ) {
    super(formManager, CardMIFiltersMeta);
  }
}
